import React from 'react';
import { Form, Scope } from 'informed';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import { get, map } from 'lodash';
import { API_HOST } from '../../consts';
import FormContainer from '../../containers/Form';
import Loading from '../../components/Loading';
import InputSpan from '../../components/inputs/InputSpan';
import InputCurrency from '../../components/inputs/InputCurrency';
import Detalhes from '../../components/Detalhes';
import BaseCreate from '../../base/BaseCreate';

class Pedido extends BaseCreate {
  state = {
    matrizes_referencia: [],
    markedForDeletion: [],
    fetchingData: true
  };

  componentDidMount() {
    this.fetchData();
  }

  fetchData() {
    if (this.id !== 'new') {
      axios
        .get(`${API_HOST}/encomenda/revisao/form`, {
          params: {
            encomenda: this.id,
            ordering: 'posicao'
          }
        })
        .then((response) => {
          this.setState({ fetchingData: false });
          this.formApi.setValues({ revisoes: response.data });
          this.setState({
            inicio_validacao_pedagogica: get(
              response.data,
              '[0].inicio_validacao_pedagogica',
              '-'
            ),
            termino_validacao_pedagogica: get(
              response.data,
              '[0].termino_validacao_pedagogica',
              '-'
            )
          });
        });
    } else {
      this.setState({ fetchingData: false });
    }
  }

  handleSubmit = (values) => {
    const { markedForDeletion } = this.state;
    this.setState({ submitting: true });

    values.revisoes.forEach((pedido) => {
      pedido.encomenda = this.id;
    });

    axios
      .put(`${API_HOST}/encomenda/revisao`, values.revisoes, {
        params: {
          delete: markedForDeletion.join(',')
        }
      })
      .then(() => {
        const { history } = this.props;
        history.push(this.next);
      })
      .catch(this.onValidateError);
  };

  add = () => {
    const revisoes = this.formApi.getState().values.revisoes || [];
    this.formApi.setValues({ revisoes: [{}, ...revisoes] });
  };

  remove = (i) => {
    const { revisoes } = this.formApi.getState().values;
    this.formApi.setValues({ revisoes: revisoes.filter((_, j) => j !== i) });

    const { markedForDeletion } = this.state;
    this.setState({
      markedForDeletion: [...markedForDeletion, revisoes[i].id]
    });
  };

  handleNext = (next) => {
    this.next = next;
    this.handleSubmit(this.formApi.getState().values);
  };

  render() {
    const { fetchingData, submitting } = this.state;

    return (
      <Form
        onChange={(formState) => this.setState({ formState })}
        getApi={(formApi) => {
          this.formApi = formApi;
        }}
        onSubmit={this.handleSubmit}
        initialValues={{ revisoes: [] }}
      >
        {({ formState }) => {
          if (fetchingData) {
            return <Loading />;
          }

          return (
            <React.Fragment>
              <Detalhes header="Período de validação pedagógica">
                <div className="col-sm-5">
                  <label
                    style={{ color: '#453166' }}
                    className="form-group mb-0"
                  >
                    Início
                  </label>
                  <p className="mb-0">
                    {get(this.state, 'inicio_validacao_pedagogica') || '-'}
                  </p>
                </div>
                <div className="col-sm-5">
                  <label
                    style={{ color: '#453166' }}
                    className="form-group mb-0"
                  >
                    Término
                  </label>
                  <p className="mb-0">
                    {get(this.state, 'termino_validacao_pedagogica') || '-'}
                  </p>
                </div>
              </Detalhes>
              <FormContainer
                title="Etapas de revisão"
                previous="elaboradores"
                next="revisores"
                onClick={this.handleNext}
                disabled={submitting}
              >
                {map(formState.values.revisoes, (r, i) => (
                  <Scope scope={`revisoes[${i}]`} key={r.id}>
                    <div className="card item-card mb-3" key={r.id}>
                      <div className="card-header">
                        <div className="row">
                          <div className="col-sm-12">
                            <label
                              style={{
                                color: '#453166',
                                fontSize: '20px',
                                fontWeight: 'bold'
                              }}
                              className="form-group"
                            >
                              {get(r, 'tipo_revisao.descricao')}
                            </label>
                          </div>
                          <InputSpan
                            type="number"
                            col="col-sm-4"
                            label="Quantidade de revisões"
                            leftAddon="mínimo"
                            field="minimo"
                          />
                          <InputSpan
                            type="number"
                            col="col-sm-4"
                            leftAddon="máximo"
                            field="maximo"
                          />
                          <InputCurrency
                            col="col-sm-4"
                            label="Valor por revisão"
                            field="valor_revisao"
                          />
                          <InputSpan
                            col="col-sm-5"
                            label="Período da Série/Ano"
                            leftAddon="início"
                            field="inicio"
                            type="date"
                          />
                          <InputSpan
                            col="col-sm-5"
                            leftAddon="término"
                            field="termino"
                            type="date"
                          />
                        </div>
                      </div>
                    </div>
                  </Scope>
                ))}
              </FormContainer>
            </React.Fragment>
          );
        }}
      </Form>
    );
  }
}

export default withRouter(Pedido);
